// API Configuration
const API_URLS = {
  local: 'http://localhost:3008/api',
  production: 'https://api.jivbook.com/api'
};

// Use environment variable or fallback to production API
// Set REACT_APP_API_URL in .env file to override
export const API_BASE_URL = process.env.REACT_APP_API_URL || API_URLS.production;

// Log API URL for debugging (remove in production)
console.log('🔗 API Base URL:', API_BASE_URL);
console.log('🔗 Environment:', process.env.NODE_ENV);
console.log('🔗 REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

// Default axios configuration
export const DEFAULT_API_CONFIG = {
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Helper function to get full image URL
export const getImageUrl = (imagePath: string): string => {
  if (!imagePath) return '';
  // If the imagePath is already a full URL, return it as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  // If it's a relative path, prepend the base API URL
  const baseUrl = API_BASE_URL.replace('/api', ''); // Remove /api from end
  return `${baseUrl}/${imagePath.startsWith('/') ? imagePath.slice(1) : imagePath}`;
};

export default API_BASE_URL;

